
















import {Component, Vue} from 'vue-property-decorator'
import Sidebar from '@/components/Sidebar.vue'
import CmsNetworkModeBar from '@/components/CmsNetworkModeBar.vue'
import {EnvHelper} from '@/helpers/EnvHelper'

@Component({
  components: {Sidebar, CmsNetworkModeBar},
})
export default class AuthLayout extends Vue {
  authorized = false
  collapsed = true

  get viewClass() {
    return {
      'router-view--collapsed': this.collapsed,
    }
  }

  async mounted() {
    if (EnvHelper.VUE_APP_ENV === 'development') {
      this.authorized = true
      return
    }

    // await this.$auth.authenticate()

    // if (!this.$auth.isLogged) {
    //   await this.$nav.replace('/sign-in')
    // } else {
    //   this.authorized = true
    // }

    this.authorized = true
  }

  toggleEvent(menu: boolean) {
    this.collapsed = menu
  }
}
